import { ReactNode } from "react";

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { token } from "@atlaskit/tokens";

import { Link } from "@/libraries/design/components/link/src/link";

import { useAccountSigninContext } from "../hooks/account-signin-context";

export const Error = ({ errorText }: { errorText?: ReactNode }) => {
    const { formatMessage, locale } = useIntl();
    const { formError } = useAccountSigninContext();
    if (!formError) {
        return null;
    }
    if (errorText === undefined) {
        errorText =
            locale === "en" // temporary fix until translation is available
                ? formatMessage(
                      {
                          id: "gwp.accountSignin.userSignupError",
                          defaultMessage: `It's taking longer than expected to get you started. Please refresh and try again or <contactUsLink>contact us</contactUsLink>.`
                      },
                      { contactUsLink }
                  )
                : formatMessage(
                      {
                          id: "gwp.accountSignin.formError",
                          defaultMessage:
                              "It's taking longer than expected to get you started. Please check your inbox to see if the order has completed successfully, or <contactUsLink>contact us</contactUsLink>."
                      },
                      { contactUsLink }
                  );
    }
    return (
        <p css={errorCss} role="alert">
            {errorText}
        </p>
    );
};

const contactUsLink = (text: ReactNode) => (
    <Link
        text={text as unknown as string}
        aria-label={text as unknown as string}
        type="inline"
        href="/company/contact"
        className="linkText"
    />
);

const errorCss = css({
    color: `${token("color.icon.accent.red")} !important`,
    margin: "1rem 0",
    textWrap: "pretty"
});
